import { theme } from '@chakra-ui/react'

// customized theme inspird by Artsy style-systems
export const customTheme = {
  ...theme,
  colors: {
    ...theme.colors,
    /** Full black, primary brand color  */
    black100: "#000",
    /** 80% black  */
    black80: "#333",
    /** 60% black, bold copy, lower in hierarchy  */
    black60: "#666",
    /** 30 black (dark grey), placeholder text only  */
    black30: "#C2C2C2",
    /** 10 black (grey), borders, divider lines, and grey button only */
    black10: "#E5E5E5",
    /** 5 black (light grey), backgrounds only */
    black5: "#F8F8F8",

    /** Full purple, secondary brand color. Should only used in time/transitions (on hover, active state), for highlighting vital text, and links.   */
    purple100: "#6E1EFF",
    /** 30 purple (light purple), avoid usage  */
    purple30: "#D3BBFF",
    /* 5 purple, highlight, accent */
    purple5: "#F8F3FF",

    /** Full green, success */
    green100: "#0EDA83",
    /** Full red, error */
    red100: "#F7625A",
    /** Full yellow, warn */
    yellow100: "#F1AF1B",
    /** 30 yellow (light yellow), avoid future use */
    yellow30: "#FAE7BA",
    /** 10 yellow (lightest yellow), avoid future use */
    yellow10: "#FDF7E8",
    /** Full white */
    white100: "#FFF",

    brand: {
      navyBlue: "#1a365d",
      brightBlue: "#0052cc",
      backgroundDarkPrimary: '#0747A6', // blueDark

      // all-reds
      brightRed: '#ec1b25', // bright-red 
      maroonRed: '#a80403', // maroon
      brighterRed: '#d10000', // brighter-red

      // all-yellows
      mainYellow: "#fde700",
      darkerYellow: "#f9c20f",
      lighterYellow: "#FFDC00",
      yellowNew: "#FEE715FF",
      yellowDribble: "#ffd500",

      // all-blacks
      lighterBlack: "#161a1b", // lighter--black
      alsoLighterBlack: "#212121", // also brown-tinted?! 
      svtPlayBlack: "#0b0c0e", // main--black
      blackRussian: "#242528",
      charcoalBlack: "#101820FF",

      // all-greys
      secondary: '#F4F5F7', // light grey
      textDark: '#6A6A6A', // dark-gray-text
      backgroundLightest: '#fff', // lightestGrayBg, keep!
      backgroundLight: '#ebecf0', // lightGray, keep!
      backgroundMedium: '#dfe1e6', // grayMedium

      // text-colors
      textLink: "#0052cc", // sames as brand.500
      textLight: "#fff", // 
      textMedium: "#5E6C84", // 
      textDarkest: "#0b0c0e", // same as svtPlayBlack
      textMediumDark: "#6A6A6A", // sames as textDark

      borderInputFocus: "#0747A6", // same as backgroundDarkPrimary
      borderLightest: "#dfe1e6", // same as backgroundMedium
      borderLight: "#C1C7D0", // gray-mediumDark-ish, maybe?

      // maybes?! 
      error: "#e70016", // similar to brightRed
      // brighter-shades
      success: '#2ECC40', // green
      danger: '#E13C3C', // red
      warning: '#fbe104', // yellow 
    },
  },
  semanticTokens: {
    colors: {
      error: "#e70016", // similar to brightRed
      success: '#2ECC40', // green
      danger: '#E13C3C', // red
      warning: '#fbe104', // yellow 

      text: {
        default: 'gray.900',
        _dark: 'gray.50',
      },
    },
  },
  space: {
    // unit: px value
    /** Equivalent to 3px  */
    0.3: "3px",
    /** Equivalent to 5px  */
    0.5: "5px",
    /** Equivalent to 10px  */
    1: "10px",
    /** Equivalent to 20px  */
    2: "20px",
    /** Equivalent to 30px  */
    3: "30px",
    /** Equivalent to 40px  */
    4: "40px",
    /** Equivalent to 50px  */
    6: "60px",
    /** Equivalent to 90px  */
    9: "90px",
    /** Equivalent to 120px  */
    12: "120px",
    /** Equivalent to 180px  */
    18: "180px",
  },
  icons: {
    ...theme.icons,
  },
  breakpoints: {
    sm: '320px',
    md: '768px',
    lg: '960px',
    xl: '1200px',
    '2xl': '1440px',
  },
  maxW: [
    "auto", // base
    "auto", // 480px upwards
    "auto", // 768px upwards
    "1300px", // 992px upwards
  ],
  fonts: {
    heading: "Gatwick, Gatwick-Bold,sans-serif",
    subtitle: "Gatwick-Ultralight, sans-serif",
    mono: "Menlo, monospace",
    body: "Poppins, system-ui, sans-serif",
    regular: "Poppins, sans-serif",
    // bold: 'font-family: "Poppins"; font-weight: 800;',
    // black: 'font-family: "Poppins"; font-weight: 900;',
  },
  // container: {
  //   sm: '640px',
  //   md: '768px',
  //   lg: '1024px',
  //   xl: '1280px',
  // },
  // fontSizes: {
  //   xs: "0.75rem",
  //   sm: "0.875rem",
  //   md: "1rem",
  //   lg: "1.125rem",
  //   xl: "1.5rem",
  //   "2xl": "2rem",
  //   "3xl": "3rem",
  //   "4xl": "3.25rem",
  //   "5xl": "4rem",
  //   "6xl": "9rem",
  // },
}
